export const organizationSchema = {
  "@type": "Organization",
  "@id": "https://oe-app.com/#organization",
  name: "(주)비바라비다",
  legalName: "(주)비바라비다",
  description: "4060 모임 커뮤니티 '오이' 운영사",
  url: "https://oe-app.com",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+82-15664515",
    contactType: "customer service",
    areaServed: "KR",
    availableLanguage: "Korean",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "광주광역시 북구 자미로6번길 45, 509호",
    addressLocality: "광주광역시",
    postalCode: "61226",
    addressCountry: "KR",
  },
  sameAs: [
    "https://52-oi.tistory.com",
    "https://blog.naver.com/oi_blog",
    "https://www.facebook.com/oi.facebook",
    "https://www.instagram.com/oe_app_official",
  ],
};

export const softwareAppSchema = {
  "@type": "SoftwareApplication",
  "@id": "https://oe-app.com/#app",
  name: "오이 - 취미 모임 · 동호회",
  url: "https://oe-app.com",
  operatingSystem: "Android, iOS",
  applicationCategory: "SocialNetworking",
  description: `바쁘게 달려오느라 나를 잊고 지냈다면, 이제는 취미 모임으로 일상을 다시 시작해 보세요. 오이는 취미를 기반으로 한 ‘오프라인 모임(동호회)’에서 사람을 만나고, 웃고, 배우며 성장하는 경험을 연결합니다.`,
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: 4.8,
    reviewCount: 683,
  },
  downloadUrl: [
    "https://play.google.com/store/apps/details?id=com.koco.oi_android",
    "https://apps.apple.com/kr/app/id6480576858",
  ],
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "KRW",
  },
  publisher: {
    "@id": "https://oe-app.com/#organization", // ✅ 참조만!
  },
};

export const recommendationQuestionPageSchema = (
  questions: {
    name: string;
    suggestedAnswers: string[];
  }[]
) => {
  return {
    "@type": "WebPage",
    url: "https://oe-app.com/recommend/survey",
    name: "내게 맞는 모임 찾기",
    description: "우리동네 나랑 딱 맞는 모임 찾아보세요",
    mainEntity: {
      "@type": "ItemList",
      name: "모임 추천 질문 목록",
      itemListElement: questions.map((question, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Question",
          name: question.name,
          suggestedAnswer: question.suggestedAnswers.map((answer) => ({
            "@type": "Answer",
            text: answer,
          })),
        },
      })),
    },
  };
};

export const faqSchema = () => {
  const faqs = [
    {
      q: "오이는 무어인가요?",
      a: "오이는 내가 원하는 관심사의 취미 모임에 참여하거나 직접 개설할 수 있는 취미기반 모임플랫폼입니다. 오이를 통해 즐거운 모임활동이 되시기를 응원하겠습니다.",
    },
    {
      q: "'오이'뜻이 무엇인가요?",
      a: "‘오이’는 “오늘부터 이팔청춘!” 이라는 의미를 담고 있습니다.",
    },
    {
      q: "모임찾기 탭은 어떤 공간인가요?",
      a: "내 주변과 다른 지역의 다양한 모임들을 구경할 수 있는 공간입니다. 마음에 드는 모임을 찾았다면 가입도 해보세요. 오른쪽 아래 “+”버튼 을 누르면 모임을 직접 만들 수도 있어요",
    },
    {
      q: "모임 가입은 어떻게 하나요?",
      a: "오이 앱 하단 ‘모임찾기’ 탭에서 나에게 맞는 모임을 탐색해보고 모임에 참여할 수 있습니다. 나에게 맞는 모임 탐색이 어렵다면 ‘홈’ 탭 하단 ‘깜이에게 모임 추천받기’를 클릭해보세요.",
    },
    {
      q: "모임을 새로 만들려면 어떻게 해야 하나요?",
      a: "'모임찾기' 탭을 클릭한 후, 우측 하단의 '+' 버튼을 클릭하고 절차에 따라 진행하시면 모임을 만들 수 있습니다.",
    },
    {
      q: "다른 지역의 모임도 구경하고 싶어요",
      a: "‘모임찾기' 탭을 클릭한 후, 최상단에 있는 ‘지역변경’ 버튼을 눌러 타지역으로 설정하면 해당 지역의 모임들을 구경할 수 있어요.",
    },
    {
      q: "친구를 모임에 초대하려면 어떻게 해야 하나요?",
      a: "모임 홈 하단의 '카톡으로 모임 초대하기' 기능을 이용해 친구를 초대할 수 있습니다.",
    },
    {
      q: "모임을 홍보하고 싶어요",
      a: "오이는 모임을 개설하면 자동으로 주변의 유저들에게 표출되고 있습니다. 또한 채팅 기능을 적극 활용해 모임을 탐색하는 회원들에게 더 많이 노출될 수 있도록 할 수 있습니다. 오프라인 모임을 자주 개최하여 모임 일정을 업데이트하면 더 많은 관심을 받을 수 있습니다. 더 많은 홍보가 필요하다면, 오이에서 자체적인 알림을 보내 신규회원 님들에게 소개해드리고 있어요",
    },
    {
      q: "전국모임랭킹은 어떻게 정해지나요?",
      a: "모임 랭킹은 모임원들의 다양한 활동을 점수화하여 순위를 매깁니다. 오프라인 모임 일정, 채팅, 모임 피드 게시 등 활동이 활발할수록 높은 점수가 반영되어 순위가 올라갑니다.",
    },
    {
      q: "모임피드에 대해 알고싶어요",
      a: `정모 후기나 다같이 찍은 사진 등 모임활동에 대한 게시물을 올리는 곳이에요. 모임홈 > 모임피드로 들어가면 업로드 할 수 있어요. 모임원들만 볼 수 있도록 하려면 게시물을 작성할 때 “모임멤버에게만 공개”를 켜주세요`,
    },
    {
      q: "매너오이가 무엇인가요?",
      a: "매너오이는 모임에 다녀온 후, 모임에 참여한 모임원 중 한 명에게 익명으로 줄 수 있습니다. 매너오이를 많이 받을수록 높은 매너 지수를 나타내는 지표가 됩니다.",
    },
  ];

  return {
    "@type": "FAQPage",
    mainEntity: faqs.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: {
        "@type": "Answer",
        text: a,
      },
    })),
  };
};

export const gatheringItemListSchema = (
  items: { id: number; name: string; image: string; description: string }[]
) => {
  return {
    "@type": "ItemList",
    name: "모임 목록",
    description: "다양한 주제의 모임을 찾아보세요.",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Thing",
        name: item.name,
        "@id": `https://oe-app.com/gathering/${item.id}`,
        url: `https://oe-app.com/gathering/${item.id}`,
        description: item.description,
        image: item.image,
      },
    })),
  };
};

export const staticArticleSchema = (article: {
  slug: string;
  title: string;
  description: string;
  thumbnail?: string;
  publishDate?: string;
}) => {
  return {
    "@type": "Article",
    headline: article.title,
    description: article.description,
    url: `https://oe-app.com/article/${article.slug}`,

    // 이미지 (옵션)
    ...(article.thumbnail && {
      image: article.thumbnail,
    }),

    // 날짜 (옵션 - 없으면 현재)
    datePublished: article.publishDate || new Date().toISOString(),
    dateModified: article.publishDate || new Date().toISOString(),

    // 작성자 = 회사
    author: {
      "@id": "https://oe-app.com/#organization",
    },

    // 발행사 = 회사
    publisher: {
      "@id": "https://oe-app.com/#organization",
    },

    // 메인 페이지
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://oe-app.com/article/${article.slug}`,
    },
  };
};

export const gatheringDetailSchema = (gathering: {
  id: number;
  name: string;
  description: string;
  image: string;
  category: string;
  location: {
    region: string;
    district: string;
  };
  memberCount: number;
  maxMembers: number;
  ageRange?: string;
  establishedYear?: string;
  meetingFrequency?: string;
  ranking?: number;
  upcomingEvents?: {
    date: string;
    title: string;
    location: string;
    currentAttendees: number;
    maxAttendees: number;
  }[];
}) => {
  return {
    "@type": "SocialEvent",
    "@id": `https://oe-app.com/gathering/${gathering.id}`,
    name: gathering.name,
    description: gathering.description
      .replaceAll("\n", " ")
      .replace(/\s+/g, " ")
      .trim(),
    url: `https://oe-app.com/gathering/${gathering.id}`,
    image: gathering.image,

    // 카테고리
    about: {
      "@type": "Thing",
      name: gathering.category,
    },

    // 위치 정보
    location: {
      "@type": "Place",
      name: `${gathering.location.region} ${gathering.location.district}`,
      address: {
        "@type": "PostalAddress",
        addressRegion: gathering.location.region,
        addressLocality: gathering.location.district,
        addressCountry: "KR",
      },
    },

    // 참여자 정보
    attendeeCount: gathering.memberCount,
    maximumAttendeeCapacity: gathering.maxMembers,

    // 연령대 (옵션)
    ...(gathering.ageRange && {
      audience: {
        "@type": "PeopleAudience",
        suggestedAge: gathering.ageRange,
      },
    }),

    // 모임 운영 기간 (옵션)
    ...(gathering.establishedYear && {
      startDate: gathering.establishedYear,
    }),

    // 모임 빈도 (옵션)
    ...(gathering.meetingFrequency && {
      eventSchedule: {
        "@type": "Schedule",
        description: gathering.meetingFrequency,
      },
    }),

    // 다가오는 일정들
    ...(gathering.upcomingEvents &&
      gathering.upcomingEvents.length > 0 && {
        subEvent: gathering.upcomingEvents.map((event) => ({
          "@type": "Event",
          name: event.title,
          startDate: event.date,
          location: {
            "@type": "Place",
            name: event.location,
          },
          attendeeCount: event.currentAttendees,
          maximumAttendeeCapacity: event.maxAttendees,
        })),
      }),

    // 추가 속성
    ...(gathering.ranking && {
      additionalProperty: {
        "@type": "PropertyValue",
        name: "전국 모임 랭킹",
        value: `${gathering.ranking}위`,
      },
    }),
  };
};

export const gatheringFeedListPageSchema = (
  feeds: {
    id: number;
    content: string;
    author: {
      id: number;
      name: string;
      profileImage?: string;
    };
    thumbnailImage: string; // 사진 또는 비디오 썸네일
    publishDate: string;
    likeCount?: number;
    commentCount?: number;
  }[],
  page: number = 1
) => {
  return {
    "@type": "WebPage",
    "@id": `https://oe-app.com/gathering/feed/list?page=${page}`,
    url: `https://oe-app.com/gathering/feed/list?page=${page}`,
    name: `모임 피드 - ${page}페이지`,
    description: "취미로 꽃 피우다. 다양한 모임의 활동 소식과 후기",

    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "홈",
          item: "https://oe-app.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "모임 피드",
          item: "https://oe-app.com/gathering/feed/list",
        },
      ],
    },

    mainEntity: {
      "@type": "ItemList",
      name: "모임 피드 목록",
      itemListElement: feeds.map((feed, index) => ({
        "@type": "ListItem",
        position: (page - 1) * feeds.length + index + 1,
        item: {
          "@type": "SocialMediaPosting",
          "@id": `https://oe-app.com/gathering/feed/${feed.id}`,
          url: `https://oe-app.com/gathering/feed/${feed.id}`,
          articleBody: feed.content
            .replaceAll("\n", " ")
            .replace(/\s+/g, " ")
            .trim()
            .substring(0, 300),
          datePublished: feed.publishDate,
          image: feed.thumbnailImage,

          author: {
            "@type": "Person",
            "@id": `https://oe-app.com/user/${feed.author.id}`,
            name: feed.author.name,
            ...(feed.author.profileImage && {
              image: feed.author.profileImage,
            }),
          },

          interactionStatistic: [
            ...(feed.likeCount !== undefined
              ? [
                  {
                    "@type": "InteractionCounter",
                    interactionType: "https://schema.org/LikeAction",
                    userInteractionCount: feed.likeCount,
                  },
                ]
              : []),
            ...(feed.commentCount !== undefined
              ? [
                  {
                    "@type": "InteractionCounter",
                    interactionType: "https://schema.org/CommentAction",
                    userInteractionCount: feed.commentCount,
                  },
                ]
              : []),
          ],

          publisher: {
            "@id": "https://oe-app.com/#organization",
          },
        },
      })),
    },
  };
};

// ⭕ 유니코드/이모지 쌍을 보존하며 문자열을 안전하게 자르는 헬퍼 함수
const safeTruncate = (text: string, maxLength: number): string => {
  if (!text) return "";
  const chars = [...text]; // 이모지를 온전한 한 글자로 쪼갭니다.
  if (chars.length <= maxLength) return text;
  return chars.slice(0, maxLength).join("").trim() + "...";
};

export const gatheringFeedDetailSchema = (feed: {
  id: number;
  content: string;
  author: {
    id: number;
    name: string;
    profileImage?: string;
  };
  gathering?: {
    id: number;
    name: string;
    category?: string;
  };
  images?: string[];
  publishDate: string;
  likeCount?: number;
  commentCount?: number;
  comments?: {
    id: number;
    author: {
      id: number;
      name: string;
      profileImage?: string;
    };
    content: string;
    publishDate: string;
  }[];
}) => {
  return {
    '@type': 'WebPage',
    '@id': `https://oe-app.com/gathering/feed/${feed.id}`,
    url: `https://oe-app.com/gathering/feed/${feed.id}`,
    name: safeTruncate(feed.content, 50),

    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '홈',
          item: 'https://oe-app.com',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '모임 피드',
          item: 'https://oe-app.com/gathering/feed/list',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: safeTruncate(feed.content, 50),
          item: `https://oe-app.com/gathering/feed/${feed.id}`,
        },
      ],
    },

    mainEntity: {
      '@type': 'SocialMediaPosting',
      '@id': `https://oe-app.com/gathering/feed/${feed.id}#posting`,
      url: `https://oe-app.com/gathering/feed/${feed.id}`,
      headline: safeTruncate(feed.content, 100),
      articleBody: feed.content,
      datePublished: feed.publishDate,

      ...(feed.images &&
        feed.images.length > 0 && {
          image: feed.images.length === 1 ? feed.images[0] : feed.images,
        }),

      author: {
        '@type': 'Person',
        '@id': `https://oe-app.com/user/${feed.author.id}`,
        name: feed.author.name,
        ...(feed.author.profileImage && {
          image: feed.author.profileImage,
        }),
      },

      ...(feed.gathering && {
        about: {
          '@type': 'SocialEvent',
          '@id': `https://oe-app.com/gathering/${feed.gathering.id}`,
          name: feed.gathering.name,
          url: `https://oe-app.com/gathering/${feed.gathering.id}`,
          ...(feed.gathering.category && {
            about: {
              '@type': 'Thing',
              name: feed.gathering.category,
            },
          }),
        },
      }),

      interactionStatistic: [
        ...(feed.likeCount !== undefined
          ? [
              {
                '@type': 'InteractionCounter',
                interactionType: 'https://schema.org/LikeAction',
                userInteractionCount: feed.likeCount,
              },
            ]
          : []),
        ...(feed.commentCount !== undefined
          ? [
              {
                '@type': 'InteractionCounter',
                interactionType: 'https://schema.org/CommentAction',
                userInteractionCount: feed.commentCount,
              },
            ]
          : []),
      ],

      ...(feed.comments &&
        feed.comments.length > 0 && {
          comment: feed.comments.map((comment) => ({
            '@type': 'Comment',
            '@id': `https://oe-app.com/gathering/feed/${feed.id}/comment/${comment.id}`,
            text: comment.content,
            dateCreated: comment.publishDate,
            author: {
              '@type': 'Person',
              '@id': `https://oe-app.com/user/${comment.author.id}`,
              name: comment.author.name,
              ...(comment.author.profileImage && {
                image: comment.author.profileImage,
              }),
            },
          })),
        }),

      publisher: {
        '@id': 'https://oe-app.com/#organization',
      },
    },
  }
};
